import React from "react"
import { IconColorsType } from "../"
import { camelize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "uber"
const UberIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-2.5-1.19v.648h-.308c-.479 0-.828.365-.828.915v2.038h-.734v-3.574h.727v.44c.183-.286.479-.468.888-.468h.255Zm-3.044 1.49a1.147 1.147 0 0 0-1.13-.916c-.545 0-1.004.362-1.13.916h2.26Zm-1.051 2.19c-1.109 0-1.971-.804-1.971-1.868 0-1.005.822-1.853 1.904-1.859 1.07 0 1.858.8 1.858 1.862v.234h-3.022a1.23 1.23 0 0 0 1.23 1.017c.432 0 .794-.169 1.07-.525l.533.375c-.372.479-.923.765-1.603.765Zm-4.266-3.1c-.705 0-1.278.544-1.278 1.239 0 .688.563 1.244 1.278 1.238.699 0 1.272-.55 1.272-1.239 0-.694-.573-1.238-1.272-1.238Zm-1.272 3.02H9.14V9.5h.734v1.782c.336-.332.8-.531 1.319-.531 1.089 0 1.951.836 1.951 1.874 0 1.033-.862 1.869-1.951 1.869-.517 0-.989-.2-1.326-.532v.449ZM5.268 9.507v3.027c0 .796.538 1.303 1.253 1.3.708 0 1.253-.525 1.253-1.303V9.503h.768v4.908H7.78v-.449a1.872 1.872 0 0 1-1.347.538c-1.099 0-1.933-.765-1.933-1.92V9.505h.768Z"
        clipRule="evenodd"
      />
    </svg>
  )
}
export default UberIcon
